import * as React from 'react';
import { No, Yes } from '../pages/components/messages';
import { Notation } from './components/Notation';
import { names, vocabularies, VocabularyName as VN } from './gen_vocabulary';
import { getVocabulary } from './util';
import { JSX } from 'react';

export { names, vocabularies };
export type VocabularyName = VN;

export const editorialStatusKeys: string[] = Array.from(getVocabulary('editorial_status_list', 'de', '*').keys());
export const pubtypeKeys: string[] = Array.from(getVocabulary('pubtype_list', 'de', '*').keys());

const defaultEntryLabels: { boolean: Map<string | boolean, JSX.Element> } = {
  boolean: new Map<string | boolean, JSX.Element>([
    [true, Yes],
    ['true', Yes],
    [false, No],
    ['false', No],
  ]),
};

export const labelMapFilter = <T>(map: Map<T, JSX.Element>) => (value: T): JSX.Element | string => {
  const result: JSX.Element = map.get(value);
  return undefined === result ? String(value) : result;
};
export const labelVocabFilter = (v: string, p: string = '') => (value: string): JSX.Element => {
  return React.createElement(Notation, {v, p, k: value});
};

export const boolFilter = labelMapFilter(defaultEntryLabels.boolean);
export const editStatusFilter = labelVocabFilter('editorial_status_list', '*');
export const subjectClassifDfgFilter = labelVocabFilter('dfg_subject_list', '*');
export const subjectClassifKdsfFilter = labelVocabFilter('kdsf_subject_list', '*');
export const subjectClassifAsjcFilter = labelVocabFilter('asjc_subject_list', '*');
export const subjectClassifAscatypeFilter = labelVocabFilter('ascatype_subject_list', '*');
export const subjectClassifOpenAlexFieldsFilter = labelVocabFilter('openalex_fields_subject_list', '*');
export const subjectClassifOpenAlexSubfieldsFilter = labelVocabFilter('openalex_subfields_subject_list', '*');
export const subjectClassifDnbFilter = labelVocabFilter('dnb_subject_list', '*');
export const pubStatusFilter = labelVocabFilter('publication_status_list', '*');
export const personStatusFilter = labelVocabFilter('person_status_list', '*');
export const formSubjectFilter = labelVocabFilter('form_subject_list', '*');
export const externalIdentifierFilter = labelVocabFilter('external_id_list', '*');
export const personIdentifierFilter = labelVocabFilter('external_person_id_list', '*');
export const unitIdentifierFilter = labelVocabFilter('external_unit_id_list', '*');
export const funderFilter = labelVocabFilter('funder_list', '*');
export const accessLevelFilter = labelVocabFilter('access_level', '*');
export const pubtypeFilter = labelVocabFilter('pubtype_list', '*');
export const resourceTypeFilter = labelVocabFilter('resource_type_list', '*');
export const affiliationFilter = labelVocabFilter('affiliations_list', '*');
export const fundedTypeFilter = labelVocabFilter('funded_list', '*');
export const peerReviewStatusFilter = labelVocabFilter('peer_review_status_list', '*');
export const languageFilter = labelVocabFilter('language_list', '*');
